import { render, staticRenderFns } from "./ManageMedicalHospitalization.vue?vue&type=template&id=6cee19a8&scoped=true"
import script from "./ManageMedicalHospitalization.vue?vue&type=script&lang=js"
export * from "./ManageMedicalHospitalization.vue?vue&type=script&lang=js"
import style0 from "./ManageMedicalHospitalization.vue?vue&type=style&index=0&id=6cee19a8&prod&scoped=true&lang=css"
import style1 from "./ManageMedicalHospitalization.vue?vue&type=style&index=1&id=6cee19a8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cee19a8",
  null
  
)

export default component.exports